<!-- <ng-container *ngIf="this.mailDynamicData?.companyName"> -->
<ng-container *ngIf="showCompose">
    <div class="create-mail-container shadow-md" [class.minimized]="minimized" #mailContainer>
        <div class="title d-flex align-items-center justify-content-space-between px-4 py-2">
            <h4 class="mb-0 fs-24 fw-semibold">
                {{
                email_data?.type === "reply"
                ? "Reply"
                : email_data?.type === "replyAll"
                ? "Reply All"
                : email_data?.type === "forward"
                ? "Forward"
                : "Compose"
                }}
            </h4>
            <div class="d-flex gap-x-2">
                <button class="close-btn bg-transparent p-0 border-none" (click)="toggleMainimize()">
                    <span class="material-symbols-outlined fs-16 text-black">{{minimized ? 'maximize' : 'minimize'}}</span>
                </button>
                <button class="close-btn bg-transparent p-0 border-none" (click)="toggleMailView()">
                    <span class="material-symbols-outlined fs-16 text-black">{{
                        createMailWindowState
                        ? "close_fullscreen"
                        : "open_in_full"
                        }}</span>
                </button>
                <button class="close-btn bg-transparent p-0 border-none" (click)="close()">
                    <span class="material-symbols-outlined fs-16 text-black">close</span>
                </button>
            </div>
        </div>
        <div *ngIf="!minimized" class="create-mail-box scrollable-dialog create-mail position-relative {{
                    createMailWindowState ? 'px-4' : 'px-0'
                }}">
            <form [formGroup]="compose_email_form" (ngSubmit)="sendMail()" class="form-wrapper">
                <div class="w-100 d-flex">
                    <div class="alert alert-tagus p-10 fw-semibold mt-10 fixed-from" role="alert">
                        <span>From</span>
                    </div>
                    <div class="tagus-form-group without-icon ms-10 w-100">
                        <mat-form-field appearance="fill">
                            <mat-label>From Mail</mat-label>
                            <mat-select class="form-control" formControlName="from"
                                (selectionChange)="changedSelection($event)">
                                <mat-option *ngFor="let align_mails of align_inbox_mail" [value]="align_mails.mail">
                                    {{ align_mails.mail }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <div class="w-100 d-flex">
                    <div class="alert alert-tagus p-10 fw-semibold fixed-from" role="alert">
                        To
                    </div>
                    <div class="tagus-form-group without-icon w-100 ms-10 me-10">
                        <app-chip-input [formControl]="formControls.to" [suggestions]="suggestions"
                            (onSearch)="onKeydown($event, 'to')" [showLoader]="isLoading['to']"></app-chip-input>
                    </div>

                    <a href="javascript:void(0)" class="pt-10 custom-right-10" (click)="showCC()" *ngIf="!is_cc">CC</a>
                    <a href="javascript:void(0)" class="pt-10" (click)="showBCC()" *ngIf="!is_bcc">BCC</a>
                </div>
                <div class="w-100 d-flex" *ngIf="is_cc">
                    <div class="alert alert-tagus p-10 fw-semibold fixed-from" role="alert">
                        CC
                    </div>
                    <div class="tagus-form-group without-icon mb-10 ms-10 me-10 w-100">
                        <app-chip-input [formControl]="formControls.cc" [suggestions]="suggestionsForCC"
                            (onSearch)="onKeydown($event, 'cc')" [showLoader]="isLoading['cc']"></app-chip-input>
                    </div>
                </div>
                <!-- bcc input -->
                <div class="w-100 d-flex" *ngIf="is_bcc">
                    <div class="alert alert-tagus p-10 fw-semibold fixed-from" role="alert">
                        BCC
                    </div>
                    <div class="tagus-form-group without-icon mb-10 ms-10 me-10 w-100">
                        <app-chip-input [formControl]="formControls.bcc" [suggestions]="suggestionsForBCC"
                            (onSearch)="onKeydown($event, 'bcc')" [showLoader]="isLoading['bcc']"></app-chip-input>
                    </div>
                </div>
                <div class="tagus-form-group without-icon mt-10">
                    <mat-form-field appearance="fill">
                        <mat-label>Subject</mat-label>
                        <input matInput formControlName="subject" />
                    </mat-form-field>
                </div>
                <div class="w-100 d-flex flex-wrap gap-x-2">
                    <div class="alert alert-secondary d-flex justify-content-space-between align-items-center"
                        role="alert" *ngFor="let attachment of upload_files; index as i" [matTooltip]="
                                attachment?.name?.length > 10
                                    ? attachment?.name
                                    : ''
                            ">
                        <span class="fs-18 fw-semibold text-black">{{ attachment?.name | slice : 0 : 10 }}

                            <span *ngIf="attachment?.name?.length > 10">...</span>
                        </span>
                        <button type="button" class="close bg-transparent p-0 border-none" data-dismiss="alert"
                            aria-label="Close" (click)="removeDoc(i)">
                            <i class="ri-close-line"></i>
                        </button>
                    </div>
                </div>
                <div class="w-100 d-flex flex-wrap gap-x-2">
                    <div class="alert alert-secondary d-flex justify-content-space-between align-items-center me-5"
                        role="alert" *ngFor="
                                let def_attachment of default_attachment;
                                index as i
                            ">
                        <a href="javascript:void(0)" (click)="viewAttachment(def_attachment)" [matTooltip]="
                                    def_attachment?.fileName?.length > 15
                                        ? def_attachment?.fileName
                                        : ''
                                ">
                            {{ def_attachment?.fileName | slice : 0 : 15 }}
                            <span *ngIf="def_attachment?.fileName?.length > 15">...</span>
                        </a>
                        <button type="button" class="close bg-transparent p-0 border-none" data-dismiss="alert"
                            aria-label="Close" (click)="
                                    removeDefaultAttachment(i);
                                    $event.stopPropagation()
                                ">
                            <i class="ri-close-line"></i>
                        </button>
                    </div>
                </div>
                <div class="tagus-form-group mb-20">
                    <div class="NgxEditor__Wrapper" *ngIf="showCompose">
                        <app-summernote-editor 
                        #summernoteEditor
                        [initialHtml]="compose_email_form.get('html').value"
                            (contentChanged)="contentChanged($event)"></app-summernote-editor>
                    </div>
                    <mat-error *ngIf="
                                is_submitted &&
                                compose_email_form.get('html').hasError('required')
                            ">
                        Please type something
                    </mat-error>
                </div>
                <!-- <div [ngxSummernote] formControlName="html" name="html"></div> -->
                <!-- <div *ngIf="false">
                        <div
                            [ngxSummernote]="config"
                            formControlName="html"
                            name="html"
                        ></div>
                    </div>
                    <div class="tagus-form-group mt-25">
                        <input
                            type="file"
                            style="display: none"
                            #open_file
                            multiple
                            (change)="selectFiles($event)"
                        />
                        <mat-form-field appearance="fill">
                            <i class="ri-attachment-line"></i>
                            <input
                                matInput
                                placeholder="Choose File"
                                (click)="open_file.click()"
                            />
                        </mat-form-field>
                    </div> -->

                <div class="btn-box" *ngIf="false">
                    <button mat-flat-button type="submit" class="tagus">
                        <!-- {{
                            email_data?.type === 'reply' ? 'Reply' : email_data?.type === 'forward' ? 'Forward' : 'Send'
                        }} -->
                        Send
                    </button>
                    <button mat-flat-button type="button" color="warn" (click)="close()">
                        Discard
                    </button>
                </div>
            </form>

            <div class="fixed-bottom px-4 py-2 w-100">
                <div class="row">
                    <div class="col-6 d-flex align-items-center">
                        <button mat-stroked-button (click)="open_file.click()">
                            <i class="ri-attachment-line cursor-pointer fs-18"></i>
                            Attach Files
                        </button>
                        <input type="file" style="display: none" #open_file multiple (change)="selectFiles($event)" />
                    </div>
                    <div class="col-6 cz-file-check-btn-container">
                        <button mat-flat-button type="button" class="tagus me-10" (click)="sendMail()">
                            Send
                        </button>
                        <button mat-flat-button type="button" color="warn" class="me-20" (click)="close()">
                            Discard
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>


<!-- </ng-container> -->